import { Token } from '@capacitor/push-notifications';
import { createReducer, on } from '@ngrx/store';

import * as fromPersistedStateActions from '../actions/persisted-state.actions';
import * as fromPushNotificationsActions from '../actions/push-notifications.actions';
import * as fromSettingActions from '../actions/setting.actions';

export const pushNotificationsFeatureKey = 'pushNotifications';

export interface State {
  registrationError: Error | null;
  registrationInitiated: boolean;
  token: Token | null;
}

export const initialState: State = {
  registrationError: null,
  registrationInitiated: false,
  token: null
};

export const reducer = createReducer(
  initialState,
  on(fromPushNotificationsActions.registration, (state) => ({
    ...state,
    registrationError: initialState.registrationError,
    registrationInitiated: true,
    token: initialState.token
  })),
  on(fromPushNotificationsActions.registrationSuccess, (state, { payload }) => ({
    ...state,
    token: payload
  })),
  on(fromPushNotificationsActions.registrationFailure, (state, { payload }) => ({
    ...state,
    registrationError: payload.error
  })),
  on(
    fromSettingActions.loadSettingsReset,
    fromPersistedStateActions.persistedStateReset,
    fromPersistedStateActions.loadPersistedStateFailure,
    () => ({
      ...initialState
    })
  ),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[pushNotificationsFeatureKey]
  }))
);
